import React, {FC} from "react"
import PropTypes from "prop-types"

import appsConfig from "@irati-web/app/src/routeConfig"
import {FormattedMessage} from "@irati/utils/lang"

import MenuLink from "./MenuLink"

interface Context {
  apps: typeof appsConfig
}

const AccountSideBarLogout: FC = (props, {apps}: Context) => {
  return (
    <MenuLink {...props} to="/" app={apps.ACCOUNT}>
      <FormattedMessage id="account.sidebar.link" />
    </MenuLink>
  )
}

AccountSideBarLogout.contextTypes = {
  apps: PropTypes.object.isRequired
}

export default AccountSideBarLogout
